import {RejectOrderRequest} from "../api/ApiTypes.ts";
import React, {useState} from "react";
import {useOrderApi} from "../context/ApiContext.tsx";
import SamButton from "./SamButton.tsx";
import CancelButton from "./CancelButton.tsx";


interface RejectOrderProps {
    orderId: number,
    onSuccess: () => void;
    onCancel: () => void;
}

export const RejectOrderForm: React.FC<RejectOrderProps> = ({
    orderId,
    onSuccess,
    onCancel
}) => {

    const defaultState: RejectOrderRequest = {
        orderId: orderId,
        rejectMessage: ''
    };

    const [ formData, setFormData ] = useState<RejectOrderRequest>(defaultState);
    const orderApi = useOrderApi()

    const handleSubmit = (e : React.FormEvent) => {
        e.preventDefault();

        orderApi.reject(formData).then(_ => {
            onSuccess();
        }).catch(console.log);
    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {

        const { name, value, type } = e.target;

        // Type guard to handle checkbox inputs
        const inputValue = type === 'checkbox'
            ? (e.target as HTMLInputElement).checked
            : value;

        setFormData(prevState => ({
            ...prevState,
            [name]: inputValue
        }));
    };

    const handleCancel = () => {
        setFormData(defaultState);
        onCancel();
    }

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
                <label htmlFor="condReason">Reason</label>
                <input
                    type="text"
                    name="rejectMessage"
                    id="condReason"
                    value={formData.rejectMessage}
                    onChange={handleInputChange}
                    required
                    className="w-full p-2 border-2 border-gray-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
                />
            </div>

            <div className="flex justify-end space-x-2">
                <CancelButton
                    type="button"
                    onClick={handleCancel}
                >
                    Cancel
                </CancelButton>
                <SamButton
                    type="submit"
                >
                    Reject
                </SamButton>
            </div>
        </form>
    )
}